module.exports = __webpack_public_path__ + "img/mountain.74b04560.svg";